import React from "react";
import useWindowTools from "../../../react-hooks/useWindowTools";
import {FarmyImage} from "../../../react-components/tools/nextjs-compatibility-layer";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const InfoBadge = (props) => {
  const {image, color, children, className = "", style} = props;
  const {isMobile} = useWindowTools();

  const iconWidths = theme.productIconWidths;

  const getMargin = () => {
    return isMobile ? "margin-bottom-10" : "margin-bottom-20";
  };

  return <div
    className={`
        pdp-info-badge
        text-color-white
        font-weight-900
        flex
        align-items-center
        border-radius-sm
        ${getMargin()}
        ${className}
      `}
    style={{
      minWidth: "max-content",
      maxHeight: isMobile ? "40px" : "60px",
      fontSize: isMobile ? "12px" : "14px",
      padding: `3px 10px 3px ${isMobile ? "37px" : "50px"}`,
      gap: "7px",
      backgroundColor: `color-mix(in srgb,${color} 85%,#0000 0%`,
      ...style
    }}
  >
    <div
      className={`
        position-absolute
        info-badge-icon
        border-radius-full
        border-color-white
        flex
        align-items-center
        justify-content-center
      `}
      style={{
        border: "2px solid",
        backgroundColor: `color-mix(in srgb,${color} 75%, #ffffff 30%`,
        left: "5px",
        width: `${iconWidths[isMobile ? "mobile" : "desktop"]}px`,
        height: `${iconWidths[isMobile ? "mobile" : "desktop"]}px`
      }}
    >
      {image && <FarmyImage
        className="icon-img full-height"
        src={image}
        style={{
          width: isMobile ? "18px" : "20px"
        }}
      />}
    </div>

    {children}
  </div>;
};

export default InfoBadge;
